import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchChatViewService {
  private isOpen = new BehaviorSubject<boolean>(false);
  isOpen$ = this.isOpen.asObservable();

  toggleSearchChatModal() {
    this.isOpen.next(!this.isOpen.value);
  }

  getSearchChatModal() {
    return this.isOpen.value;
  }
}
